module.exports = __webpack_public_path__ + "static/arozcaldo-67d7d35c167c1b55961e43c0a3632e91.jpg";